import React, {FC, useEffect, useState} from 'react';
import { LeftCardDetailProps } from './LeftCardDetail.props';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { images } from '../../constants/images';
// import TimelapseIcon from '@mui/icons-material/Timelapse';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import moment from 'moment';
import {getCertHandler, parseImgURL, sanitizeHTML} from '../../utils/util';
import './styles/mobile.css';
import './styles/ipad.css';
import './LeftCardDetail.css';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SchoolIcon from '@mui/icons-material/School';
import { useAppSelector } from '../../redux/hooks';
import {
  getCertificateEvents,
  getCertificateEventsDataSelector
} from '../../redux/getCertificateSlice';
import { useDispatch } from 'react-redux';
import { LoadingPage } from '../LoadingPage';
import { convertUtcToTimezone } from '../../utils/dateTimeHelper';
import {
  FORMAT_DATE,
  COURSE_POLICY_STATUS,
  TYPE_LETF_CARD_DETAIL,
  STATUS_COURSE,
  HAS_VALUES,
  CATEGORY_TYPE
} from '../../constants/constants';
import {DialogConfirm} from "../DialogConfirm";
import { CoursePolicy } from '../CoursePolicy';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const LeftCardDetail: FC<LeftCardDetailProps> = (props) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'));
  const dispatch = useDispatch<any>();
  let { leftCardDetailsData } = props;
  const utcByTimezone = convertUtcToTimezone(leftCardDetailsData?.cp_end_date);
  const { isLoading } = useAppSelector(getCertificateEventsDataSelector);
  const learningOutcome = leftCardDetailsData?.tp_learning_outcome || '';
  const courseOverview = leftCardDetailsData?.tp_overview || '';

  const policyStatus = ['N/A', 'Not Accepted','Accepted']
  const [openCoursePolicyConfirm, setOpenCoursePolicyConfirm] = useState(false)
  const [openCoursePolicy, setOpenCoursePolicy] = useState(false);

  useEffect(()=> {
    if(leftCardDetailsData &&
      leftCardDetailsData.course_policy_status === COURSE_POLICY_STATUS.MANDATORY && // course has been assigned Policy but not accepted
      leftCardDetailsData.is_passed_course === 1 &&  // course has been completed
      props.type === TYPE_LETF_CARD_DETAIL.ASSIGNED_LEARNING && // only Assigned Learning page
      leftCardDetailsData.training_label !== STATUS_COURSE.PASS // different completed status
    ){
      setOpenCoursePolicyConfirm(true);
    } else {
      setOpenCoursePolicyConfirm(false) ;
    }
    return () => {
      leftCardDetailsData = {}
    }
  },[leftCardDetailsData])
  const contentCoursePolicyConfirm = <>
    <Typography>
      You have recently passed a course without accepting the attached policy.
    </Typography>
    <br />
    <Typography>
      Please review the policy in order to officially pass the course.
    </Typography>
  </>
  const handleCloseCoursePolicyConfirm = () => {
    setOpenCoursePolicyConfirm(false);
  };
  const handleSaveCoursePolicyConfirm = () => {
    setOpenCoursePolicyConfirm(false);
    handleOpenCoursePolicy();
  };

  const checkStatusLabel =(trainingLabel:string | undefined)=>{
    return trainingLabel === STATUS_COURSE.PASS ? 'Passed' : trainingLabel;
  }

  const handleOpenCoursePolicy = () => {
    setOpenCoursePolicy(true);
  };

  const handleCloseCoursePolicy = () => {
    setOpenCoursePolicy(false);
  };

  return (
    <>
      <Card
        className={'card-detail card-detail-mobile'}
        sx={{ boxShadow: 'none', borderRadius: '0' }}
      >
        <CardContent
          className={'card-detail-card-content'}
          sx={{ display: 'flex', padding: '17px 10px' }}
        >
          <div className={'wrapper-mobile-detail'}>
            <CardMedia
              component="img"
              image={
                `${parseImgURL(leftCardDetailsData?.tp_thumbnail, leftCardDetailsData?.tp_id) ||
                images.Rectangle}`
              }
              className={'img-detail'}
              alt={leftCardDetailsData?.tp_thumbnail || ''}
              sx={{borderRadius: '20px', width:'230px', height:'230px'}}
            />
          </div>

          <CardContent className={'card-detail-card-sub-content'}>
            <div className={"training-name-wrapper"}>
              <Typography className={`training-name ${isTablet ? '' : 'text-truncate'}`}>
                {leftCardDetailsData?.course_category_name}
              </Typography>
            </div>

            <Typography className={`course-name ${isTablet ? '' : 'text-truncate'}`}>
              {leftCardDetailsData?.course_name}
            </Typography>

            <div className={'wrapper-info'}>
              {/*<Typography className={'estimate-duration'}>*/}
              {/*  <TimelapseIcon sx={{ marginBottom: '-7px' }} className={'timelapse'} />{' '}*/}
              {/*  {leftCardDetailsData?.tp_estimation_duration + ' minutes' ?? ' '}.*/}
              {/*</Typography>*/}
              <Typography className={'camp-end-date'}>
                <InsertInvitationIcon
                  sx={{ marginBottom: '-7px', marginRight: '5px' }}
                  className={'insert-invitation'}
                />
                Due Date: <span style={{color:'black'}}>{utcByTimezone ? moment(utcByTimezone).format(FORMAT_DATE.DATE_DAY_MONTH_YEAR): ''}</span>
              </Typography>
              <Typography className={'camp-end-date'}>
                <SchoolIcon
                  sx={{ marginBottom: '-7px', marginRight: '5px' }}
                  className={'insert-invitation'}
                />
                Course Status: <span style={{color:'black'}}>
                {checkStatusLabel(leftCardDetailsData?.training_label)}
              </span>
              </Typography>
              <Typography className={'camp-end-date'} sx={leftCardDetailsData?.course_policy_status ? null : {visibility: 'hidden'} }>
                <AssignmentIcon
                  sx={{ marginBottom: '-7px', marginRight: '5px'}}
                  className={'insert-invitation'}
                />
                Policy Status:
                {leftCardDetailsData?.course_policy_status === COURSE_POLICY_STATUS.MANDATORY ?
                  <span className={'insert-invitation'} style={{color:'red'}}> {policyStatus[leftCardDetailsData?.course_policy_status ]}*</span> :
                  <span className={'insert-invitation'} style={{color:'black'}}> {policyStatus[leftCardDetailsData?.course_policy_status || 0]}</span>}
              </Typography>
            </div>

            {leftCardDetailsData?.campaign_category !== CATEGORY_TYPE.QUESTIONNAIRE ? <CardActions sx={{ padding: '0', alignItems:'flex-end'}} className={'card-actions-button-wrapper'}>
              <Stack spacing={2}
                     direction="row"
                     useFlexGap
                     sx={{ flexWrap: 'wrap' }}>
                {leftCardDetailsData?.course_policy_status ?
                <Button
                  variant="outlined"
                  className={'general-button courses-policy-button'}
                  disabled={(leftCardDetailsData?.training_label === STATUS_COURSE.PASS || leftCardDetailsData.is_passed_course === HAS_VALUES.TRUE ) ? false : true }
                  onClick={handleOpenCoursePolicy}
                >
                  Course Policy
                </Button> : null }

                <Button
                  variant="contained"
                  disabled={leftCardDetailsData?.course_policy_status === COURSE_POLICY_STATUS.ACCEPTED || (leftCardDetailsData?.course_policy_status === COURSE_POLICY_STATUS.NA && leftCardDetailsData.training_label === STATUS_COURSE.PASS ) ? false : true}
                  className={'general-button get-cert-button'}
                  onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    getCertHandler(dispatch, getCertificateEvents, leftCardDetailsData?.phish_id, event);
                  }}
                >
                  Certificate
                </Button>
              </Stack>
            </CardActions>: null}
          </CardContent>
        </CardContent>
      </Card>
      {(leftCardDetailsData?.course_policy_status === COURSE_POLICY_STATUS.MANDATORY &&
        leftCardDetailsData.is_passed_course === HAS_VALUES.TRUE &&
        leftCardDetailsData?.training_label !== STATUS_COURSE.PASS) && <div className={'alert-message-detail'}>
        <p style={{margin:0}}>You are required by your organisation to read and accept the policy attached to this course.</p>
      </div>}
      {/*<div className={'mobile-divider'}>*/}
      {/*  <Divider light />*/}
      {/*</div>*/}
        <Divider light />
      {/*</div>*/}
      <Stack
        direction={'column'}
        className={'course-body'}
        spacing={'32px'}
        sx={{ marginTop: '46px' }}
      >
        <Typography component={'div'}>
          <Typography className={'card-title-overview'}>Course Overview:</Typography>
          <div className={'card-content-overview'} dangerouslySetInnerHTML={{ __html: sanitizeHTML(courseOverview) }}>
          </div>
        </Typography>
        <Typography component={'div'}>
          <Typography className={'card-title-overview'}>Learning Outcomes:</Typography>
          <div className={'card-content-overview'} dangerouslySetInnerHTML={{ __html: sanitizeHTML(learningOutcome) }}>
          </div>
        </Typography>
        <CoursePolicy
          open={openCoursePolicy}
          onClose={handleCloseCoursePolicy}
          trainingResultId={leftCardDetailsData?.training_result_id}
          coursePolicyStatus={leftCardDetailsData?.course_policy_status}
          phishId={leftCardDetailsData?.phish_id}
          campaignId={leftCardDetailsData?.campaign_id}
          coursePolicyEnableDownload={leftCardDetailsData?.enable_download_policy}
        />
      </Stack>
      <LoadingPage open={isLoading} />
      <DialogConfirm
        open={openCoursePolicyConfirm}
        title={'Course Policy to Review'}
        content={contentCoursePolicyConfirm}
        handleClose={handleCloseCoursePolicyConfirm}
        handleSave={handleSaveCoursePolicyConfirm}
      />
    </>
  );
};
